// store/notificationReducer.js

// Initial state
const initialState = { count: 0 };

// Action type
const SET_NOTIFICATION_COUNT = "SET_NOTIFICATION_COUNT";

// Action creator
export const setNotificationCount = (count) => ({
  type: SET_NOTIFICATION_COUNT,
  payload: count,
});

// Reducer
export const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATION_COUNT:
      return { ...state, count: action.payload };
    default:
      return state;
  }
};
